export const roundValue = (val: number, fractionDigits = 2): number => {
    return val % 1 !== 0 ? Number(val.toFixed(fractionDigits)) : val
}
